/**
 * LegalPage — Aviso legal, Privacidad, Cookies y Condiciones de venta.
 * Rutas: /aviso-legal · /privacidad · /cookies · /condiciones-venta
 *
 *  SUSTITUIR ANTES DE PUBLICAR los marcadores:
 *   [NOMBRE Y APELLIDOS]  [NIF]  [DIRECCIÓN FISCAL]  [EMAIL DE CONTACTO]
 */
import { useParams, Link } from "react-router-dom";

const TITULAR = {
  nombre: "Ana Guerrero Aranguez",
  nif: "XXX",
  direccion: "Navatejera - Leon",
  email: "info@esmaltealfuegoguerrero.com",
  web: "esmaltealfuegoguerrero.com",
};

function H({ children }) {
  return <h2 className="font-serif-display text-2xl mt-10 mb-4">{children}</h2>;
}
function P({ children }) {
  return <p className="mb-4 leading-relaxed text-[15px]">{children}</p>;
}
function Li({ children }) {
  return <li className="mb-2 leading-relaxed text-[15px] ml-5 list-disc">{children}</li>;
}

/* ────────────────────────── AVISO LEGAL ────────────────────────── */
function AvisoLegal() {
  return (
    <>
      <P>
        En cumplimiento de la Ley 34/2002, de Servicios de la Sociedad de la
        Información y de Comercio Electrónico (LSSI-CE), se informa de que el
        sitio web {TITULAR.web} es titularidad de:
      </P>
      <ul className="mb-6">
        <Li><strong>Titular:</strong> {TITULAR.nombre}</Li>
        <Li><strong>NIF:</strong> {TITULAR.nif}</Li>
        <Li><strong>Domicilio:</strong> {TITULAR.direccion}</Li>
        <Li><strong>Email de contacto:</strong> {TITULAR.email}</Li>
        <Li><strong>Actividad:</strong> elaboración y venta de joyería y piezas artesanales de esmalte al fuego.</Li>
      </ul>
      <H>Condiciones de uso</H>
      <P>
        El acceso y uso de este sitio web atribuye la condición de usuario e
        implica la aceptación de las presentes condiciones. El usuario se
        compromete a hacer un uso adecuado de los contenidos y a no emplearlos
        para actividades ilícitas o contrarias a la buena fe.
      </P>
      <H>Propiedad intelectual</H>
      <P>
        Todos los contenidos de este sitio (textos, fotografías, diseños de las
        piezas, logotipos e imágenes) son titularidad de {TITULAR.nombre} o se
        publican con autorización de sus titulares. Queda prohibida su
        reproducción, distribución o transformación sin autorización expresa.
      </P>
      <H>Responsabilidad</H>
      <P>
        El titular no se hace responsable de los daños derivados del mal uso del
        sitio web ni de interrupciones técnicas ajenas a su voluntad, y se
        reserva el derecho a modificar los contenidos sin previo aviso.
      </P>
      <H>Legislación aplicable</H>
      <P>
        Las presentes condiciones se rigen por la legislación española. Para
        cualquier controversia, las partes se someten a los juzgados y
        tribunales que correspondan conforme a la normativa de consumidores.
      </P>
    </>
  );
}

/* ────────────────────────── PRIVACIDAD ────────────────────────── */
function Privacidad() {
  return (
    <>
      <P>
        Esta política describe cómo se tratan los datos personales de acuerdo con
        el Reglamento (UE) 2016/679 (RGPD) y la LO 3/2018 (LOPDGDD).
      </P>
      <H>Responsable del tratamiento</H>
      <P>
        {TITULAR.nombre}, NIF {TITULAR.nif}, con domicilio en {TITULAR.direccion}.
        Contacto: {TITULAR.email}.
      </P>
      <H>Qué datos tratamos y para qué</H>
      <ul className="mb-6">
        <Li><strong>Cuenta de usuario:</strong> nombre, email y contraseña (cifrada). Finalidad: gestionar tu cuenta y tus pedidos. Base jurídica: ejecución de contrato.</Li>
        <Li><strong>Pedidos:</strong> nombre, dirección postal, teléfono y email. Finalidad: preparar, enviar y facturar tu compra. Base jurídica: ejecución de contrato y obligación legal (facturación).</Li>
        <Li><strong>Formulario de contacto:</strong> nombre, email, teléfono y consulta. Finalidad: responder a tu mensaje. Base jurídica: consentimiento.</Li>
        <Li><strong>Analítica propia:</strong> páginas visitadas, referencia y dirección IP anonimizada (truncada). Finalidad: estadísticas de uso del sitio. Base jurídica: interés legítimo. No se utilizan herramientas de analítica de terceros.</Li>
      </ul>
      <H>Destinatarios y encargados de tratamiento</H>
      <P>No se ceden datos a terceros salvo obligación legal. Prestan servicios como encargados de tratamiento:</P>
      <ul className="mb-6">
        <Li><strong>Stripe Payments Europe, Ltd.</strong> — procesamiento del pago. Los datos de tu tarjeta los recoge directamente Stripe; nunca se almacenan en nuestros servidores.</Li>
        <Li><strong>Resend</strong> — envío de emails transaccionales (confirmaciones de pedido).</Li>
        <Li><strong>Contabo GmbH</strong> — alojamiento del sitio web en servidores situados en la Unión Europea.</Li>
      </ul>
      <H>Plazos de conservación</H>
      <ul className="mb-6">
        <Li>Datos de pedidos y facturación: durante los plazos de prescripción fiscal legalmente exigidos.</Li>
        <Li>Mensajes de contacto: hasta 12 meses desde su resolución.</Li>
        <Li>Datos de analítica: hasta 12 meses.</Li>
        <Li>Cuenta de usuario: mientras la cuenta permanezca activa.</Li>
      </ul>
      <H>Tus derechos</H>
      <P>
        Puedes ejercer los derechos de acceso, rectificación, supresión,
        oposición, limitación y portabilidad escribiendo a {TITULAR.email},
        indicando el derecho que deseas ejercer y adjuntando un medio de
        verificación de identidad. También puedes reclamar ante la Agencia
        Española de Protección de Datos (aepd.es).
      </P>
    </>
  );
}

/* ────────────────────────── COOKIES ────────────────────────── */
function Cookies() {
  return (
    <>
      <P>
        Este sitio web utiliza únicamente <strong>cookies técnicas</strong>,
        estrictamente necesarias para su funcionamiento. Conforme a la normativa
        vigente, este tipo de cookies no requiere consentimiento previo.
      </P>
      <H>Cookies utilizadas</H>
      <ul className="mb-6">
        <Li><strong>access_token</strong> — cookie de sesión que mantiene tu inicio de sesión. Duración: 12 horas.</Li>
        <Li><strong>refresh_token</strong> — permite renovar la sesión sin volver a introducir la contraseña. Duración: 7 días.</Li>
      </ul>
      <H>Cookies de terceros</H>
      <P>
        Durante el proceso de pago serás redirigido a la pasarela segura de
        Stripe, que puede instalar sus propias cookies en su dominio conforme a
        su política (stripe.com/cookies-policy).
      </P>
      <P>
        No utilizamos cookies de analítica de terceros, publicidad ni seguimiento.
        Las estadísticas de visitas se elaboran con medios propios y con la
        dirección IP anonimizada.
      </P>
      <H>Cómo eliminar las cookies</H>
      <P>
        Puedes borrar o bloquear las cookies desde la configuración de tu
        navegador. Ten en cuenta que sin las cookies técnicas no podrás iniciar
        sesión ni completar compras.
      </P>
    </>
  );
}

/* ─────────────────── CONDICIONES DE VENTA ─────────────────── */
function CondicionesVenta() {
  return (
    <>
      <P>
        Las presentes condiciones regulan la compra de productos en {TITULAR.web},
        titularidad de {TITULAR.nombre} (NIF {TITULAR.nif}).
      </P>
      <H>Productos y precios</H>
      <P>
        Todas las piezas son artesanales y únicas: pueden presentar pequeñas
        variaciones de color o textura respecto a las fotografías, propias del
        esmalte al fuego. Los precios se muestran en euros con IVA incluido.
        Los gastos de envío se calculan según la zona de destino y se muestran
        antes de confirmar el pago.
      </P>
      <H>Pago</H>
      <P>
        El pago se realiza mediante tarjeta a través de la pasarela segura de
        Stripe. No almacenamos los datos de tu tarjeta.
      </P>
      <H>Envíos</H>
      <P>
        Los envíos se realizan mediante Correos (Paq Estándar) a Península,
        Baleares, Canarias, Ceuta y Melilla. El plazo habitual de entrega es de
        2 a 5 días laborables desde la confirmación del pedido para piezas en
        stock. Las piezas por encargo indican su plazo de elaboración.
      </P>
      <H>Derecho de desistimiento y devoluciones</H>
      <P>
        Dispones de <strong>14 días naturales</strong> desde la recepción del
        pedido para desistir de la compra sin necesidad de justificación,
        conforme a la Ley General para la Defensa de los Consumidores y
        Usuarios. Para ejercerlo, escribe a {TITULAR.email} indicando tu número
        de pedido. El reembolso se realizará por el mismo medio de pago en un
        plazo máximo de 14 días desde la recepción de la devolución. Los gastos
        de devolución corren a cargo del cliente. El producto debe devolverse
        en su estado original.
      </P>
      <P>
        <strong>Excepción — piezas personalizadas:</strong> conforme al
        artículo 103.c de la citada ley, quedan excluidos del derecho de
        desistimiento los productos confeccionados según las especificaciones
        del cliente o claramente personalizados (encargos a medida, grabados,
        combinaciones de color solicitadas por el cliente, etc.). Esta condición
        se indica antes de confirmar el encargo.
      </P>
      <H>Productos defectuosos</H>
      <P>
        Si una pieza llega dañada o presenta un defecto, contacta en un plazo de
        14 días con fotografías del producto y del embalaje. Se ofrecerá
        reparación, sustitución o reembolso íntegro, incluidos los gastos de
        envío, conforme a la garantía legal de 3 años para productos nuevos.
      </P>
      <H>Atención al cliente</H>
      <P>
        Para cualquier consulta o reclamación: {TITULAR.email}. También puedes
        acudir a la plataforma de resolución de litigios en línea de la UE
        (ec.europa.eu/consumers/odr).
      </P>
    </>
  );
}

/* ────────────────────────── Router de páginas ────────────────────────── */
const PAGES = {
  "aviso-legal":       { title: "Aviso legal",             eyebrow: "Legal",      body: <AvisoLegal /> },
  "privacidad":        { title: "Política de privacidad",  eyebrow: "Legal",      body: <Privacidad /> },
  "cookies":           { title: "Política de cookies",     eyebrow: "Legal",      body: <Cookies /> },
  "condiciones-venta": { title: "Condiciones de venta",    eyebrow: "Legal",      body: <CondicionesVenta /> },
};

export default function LegalPage() {
  const { slug } = useParams();
  const page = PAGES[slug] || PAGES["aviso-legal"];

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-12 md:py-20 fade-in" data-testid={`legal-${slug}`}>
      <p className="tracking-eyebrow text-[var(--eafg-muted)]">{page.eyebrow}</p>
      <h1 className="font-serif-display text-4xl md:text-5xl mt-3 mb-10">{page.title}</h1>
      <div className="text-[var(--eafg-ink)]">{page.body}</div>

      <nav className="mt-14 pt-6 border-t border-[var(--eafg-line)] flex flex-wrap gap-x-6 gap-y-2">
        {Object.entries(PAGES).map(([s, p]) => (
          <Link
            key={s}
            to={`/legal/${s}`}
            className={`tracking-eyebrow text-[0.72rem] hover:text-[var(--eafg-copper)] ${s === slug ? "text-[var(--eafg-copper)]" : "text-[var(--eafg-muted)]"}`}
          >
            {p.title}
          </Link>
        ))}
      </nav>
    </div>
  );
}
